import { checkNum } from './checkNum';

export function formatPosition4NegativeNumber(style = {}, position, { imgWidth, imgHeight }) {
    const top = position.top;
    const bottom = position.bottom;
    const left = position.left;
    const right = position.right;
    if (checkNum(top)) {
        if (top < 0) {
            style.top = `${((top / 375 - imgHeight / 3 / 375) * 100).toFixed(2)}vw`;
        } else {
            style.top = `${((top / 375) * 100).toFixed(2)}vw`;
        }
    }
    if (checkNum(bottom)) {
        if (bottom < 0) {
            style.bottom = `${((bottom / 375 - imgHeight / 3 / 375) * 100).toFixed(2)}vw`;
        } else {
            style.bottom = `${((bottom / 375) * 100).toFixed(2)}vw`;
        }
    }
    if (checkNum(left)) {
        if (left < 0) {
            style.left = `${((left / 375 - imgWidth / 3 / 375) * 100).toFixed(2)}vw`;
        } else {
            style.left = `${((left / 375) * 100).toFixed(2)}vw`;
        }
    }
    if (checkNum(right)) {
        if (right < 0) {
            style.right = `${((right / 375 - imgWidth / 3 / 375) * 100).toFixed(2)}vw`;
        } else {
            style.right = `${((right / 375) * 100).toFixed(2)}vw`;
        }
    }
    return style;
}
